import { useEffect } from 'react'
import { useAlertBox } from '../../../../contexts'
import {
  AlertDialogBody,
  AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay
} from './alert_box_styled'
import { Button } from '../../components'
import { replaceHtmlEntity } from '../../../../utils/text_replace'

const AlertBox = () => {
  const { content, open, closeBox, buttons } = useAlertBox()
  if (!open) return null

  useEffect(() => {
    const div = document.getElementById('alertContent')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [])

  return (
    <>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader />
        <AlertDialogBody>
          {typeof content === 'object'
            ? content
            : <div id="alertContent" dangerouslySetInnerHTML={{ __html: content }} />}
        </AlertDialogBody>
        {typeof content !== 'object' && (
          <AlertDialogFooter>
            {
              buttons && buttons.length > 0
                ? (
                    buttons.map((item: any, index: number) => (
                      <Button key={index} onClick={item?.action}>
                        {item.title}
                      </Button>
                    ))
                  )
                : (
                  <Button onClick={closeBox}>Fechar</Button>
                  )
            }
          </AlertDialogFooter>
        )}
      </AlertDialogContent>
    </>
  )
}

export default AlertBox
